/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meta V6|V7 API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  GetV7MetaLogKeywordCustomByUserIdParams,
  LogCustomKeywordResponse,
  LogKeywordResponse,
  PatchV7MetaLogKeywordCustomParams,
  ResultResponse,
  UpdateCustomKeywordRequest,
  UpdateKeywordRequest,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary getKeyword
 */
export const getV7MetaLogKeyword = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<LogKeywordResponse>(
    { url: `/api/v7/meta/log-keyword`, method: 'GET', signal },
    options,
  );
};

export const getGetV7MetaLogKeywordQueryKey = () => {
  return ['api', 'v7', 'meta', 'log-keyword'] as const;
};

export const getGetV7MetaLogKeywordQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7MetaLogKeyword>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7MetaLogKeyword>>, TError, TData>>;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7MetaLogKeywordQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7MetaLogKeyword>>> = ({ signal }) =>
    getV7MetaLogKeyword(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7MetaLogKeyword>>,
    TError,
    TData
  >;
};

export type GetV7MetaLogKeywordQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7MetaLogKeyword>>
>;
export type GetV7MetaLogKeywordQueryError = ErrorType<unknown>;

/**
 * @summary getKeyword
 */

export function useGetV7MetaLogKeyword<
  TData = Awaited<ReturnType<typeof getV7MetaLogKeyword>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7MetaLogKeyword>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7MetaLogKeywordQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary updateKeyword
 */
export const patchV7MetaLogKeyword = (
  updateKeywordRequest: MaybeRef<UpdateKeywordRequest[]>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  updateKeywordRequest = unref(updateKeywordRequest);

  return customAxiosInstance<ResultResponse>(
    {
      url: `/api/v7/meta/log-keyword`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateKeywordRequest,
    },
    options,
  );
};

export const getPatchV7MetaLogKeywordMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV7MetaLogKeyword>>,
    TError,
    { data: BodyType<UpdateKeywordRequest[]> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV7MetaLogKeyword>>,
  TError,
  { data: BodyType<UpdateKeywordRequest[]> },
  TContext
> => {
  const mutationKey = ['patchV7MetaLogKeyword'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV7MetaLogKeyword>>,
    { data: BodyType<UpdateKeywordRequest[]> }
  > = (props) => {
    const { data } = props ?? {};

    return patchV7MetaLogKeyword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV7MetaLogKeywordMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV7MetaLogKeyword>>
>;
export type PatchV7MetaLogKeywordMutationBody = BodyType<UpdateKeywordRequest[]>;
export type PatchV7MetaLogKeywordMutationError = ErrorType<unknown>;

/**
 * @summary updateKeyword
 */
export const usePatchV7MetaLogKeyword = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV7MetaLogKeyword>>,
      TError,
      { data: BodyType<UpdateKeywordRequest[]> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchV7MetaLogKeyword>>,
  TError,
  { data: BodyType<UpdateKeywordRequest[]> },
  TContext
> => {
  const mutationOptions = getPatchV7MetaLogKeywordMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Custom Keyword List 수정 Api
 */
export const patchV7MetaLogKeywordCustom = (
  updateCustomKeywordRequest: MaybeRef<UpdateCustomKeywordRequest[]>,
  params?: MaybeRef<PatchV7MetaLogKeywordCustomParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  updateCustomKeywordRequest = unref(updateCustomKeywordRequest);
  params = unref(params);

  return customAxiosInstance<ResultResponse>(
    {
      url: `/api/v7/meta/log-keyword/custom`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateCustomKeywordRequest,
      params: unref(params),
    },
    options,
  );
};

export const getPatchV7MetaLogKeywordCustomMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV7MetaLogKeywordCustom>>,
    TError,
    { data: BodyType<UpdateCustomKeywordRequest[]>; params?: PatchV7MetaLogKeywordCustomParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV7MetaLogKeywordCustom>>,
  TError,
  { data: BodyType<UpdateCustomKeywordRequest[]>; params?: PatchV7MetaLogKeywordCustomParams },
  TContext
> => {
  const mutationKey = ['patchV7MetaLogKeywordCustom'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV7MetaLogKeywordCustom>>,
    { data: BodyType<UpdateCustomKeywordRequest[]>; params?: PatchV7MetaLogKeywordCustomParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return patchV7MetaLogKeywordCustom(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV7MetaLogKeywordCustomMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV7MetaLogKeywordCustom>>
>;
export type PatchV7MetaLogKeywordCustomMutationBody = BodyType<UpdateCustomKeywordRequest[]>;
export type PatchV7MetaLogKeywordCustomMutationError = ErrorType<unknown>;

/**
 * @summary Custom Keyword List 수정 Api
 */
export const usePatchV7MetaLogKeywordCustom = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV7MetaLogKeywordCustom>>,
      TError,
      { data: BodyType<UpdateCustomKeywordRequest[]>; params?: PatchV7MetaLogKeywordCustomParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchV7MetaLogKeywordCustom>>,
  TError,
  { data: BodyType<UpdateCustomKeywordRequest[]>; params?: PatchV7MetaLogKeywordCustomParams },
  TContext
> => {
  const mutationOptions = getPatchV7MetaLogKeywordCustomMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Custom Keyword List 출력 Api
 */
export const getV7MetaLogKeywordCustomByUserId = (
  userId: MaybeRef<number>,
  params?: MaybeRef<GetV7MetaLogKeywordCustomByUserIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  userId = unref(userId);
  params = unref(params);

  return customAxiosInstance<LogCustomKeywordResponse>(
    {
      url: `/api/v7/meta/log-keyword/custom/${userId}`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7MetaLogKeywordCustomByUserIdQueryKey = (
  userId?: MaybeRef<number>,
  params?: MaybeRef<GetV7MetaLogKeywordCustomByUserIdParams>,
) => {
  return [
    'api',
    'v7',
    'meta',
    'log-keyword',
    'custom',
    userId,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7MetaLogKeywordCustomByUserIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7MetaLogKeywordCustomByUserId>>,
  TError = ErrorType<unknown>,
>(
  userId: MaybeRef<number>,
  params?: MaybeRef<GetV7MetaLogKeywordCustomByUserIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7MetaLogKeywordCustomByUserId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7MetaLogKeywordCustomByUserIdQueryKey(userId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7MetaLogKeywordCustomByUserId>>> = ({
    signal,
  }) => getV7MetaLogKeywordCustomByUserId(userId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(userId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7MetaLogKeywordCustomByUserId>>,
    TError,
    TData
  >;
};

export type GetV7MetaLogKeywordCustomByUserIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7MetaLogKeywordCustomByUserId>>
>;
export type GetV7MetaLogKeywordCustomByUserIdQueryError = ErrorType<unknown>;

/**
 * @summary Custom Keyword List 출력 Api
 */

export function useGetV7MetaLogKeywordCustomByUserId<
  TData = Awaited<ReturnType<typeof getV7MetaLogKeywordCustomByUserId>>,
  TError = ErrorType<unknown>,
>(
  userId: MaybeRef<number>,
  params?: MaybeRef<GetV7MetaLogKeywordCustomByUserIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7MetaLogKeywordCustomByUserId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7MetaLogKeywordCustomByUserIdQueryOptions(userId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
